import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ThemeProvider } from './hooks/useTheme.tsx'
import { preloadRoute } from './pages/public-routes'

const container = document.getElementById("root")!;
const app = (
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
const mount = () => createRoot(container).render(app);

// Páginas pré-renderizadas (scripts/prerender.ts) já chegam com o HTML pronto. Hidratar não
// funciona: o navegador reescreve os style inline ao serializar o DOM e o React trata como
// divergência. Então o React assume a página — mas só depois de carregar o módulo da rota,
// senão o Suspense piscaria o fallback por cima do conteúdo que já está na tela.
if (container.hasChildNodes()) preloadRoute(window.location.pathname).then(mount);
else mount();
